/**
 * Guard de ruta protegida: redirige a / si no hay sesión activa, o renderiza el componente hijo.
 */
import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ element, loggedUser, requiredPermission = true }) => {
  const isAuth = loggedUser && Object.keys(loggedUser).length > 0;

  if (!isAuth) {
    // No está autenticado, redirigir al login
    return <Navigate to="/" replace />;
  }

  if (!requiredPermission) {
    // No tiene permiso para esta vista
    return <Navigate to="/not-found" replace />;
  }

  // Todo OK, renderizar el elemento
  return element;
};

export default PrivateRoute;
